import Divider from '../Divider';
import Text from '../Text';
import { Color } from '../Text/types';

import { ITabs, TOption } from './Tabs.types';

import * as styled from './Tabs.styles';

function Tabs({ options, value, onChange }: ITabs) {
  function handleChange(newStatus: TOption) {
    onChange?.(newStatus.id);
  }

  return (
    <div>
      <styled.Tabs>
        {options.map((option) => (
          <styled.Tab
            key={option.id}
            onClick={() => !option.disabled && handleChange(option)}
            isActive={value === option.id}
            disabled={option.disabled}
          >
            <Text
              color={getTitleColor(option, value)}
              variant="b400-bold"
              as="span"
            >
              {option.label}
            </Text>

            {option.bullet !== undefined && (
              <styled.Bullet>
                <Text
                  variant="caption"
                  color={value === option.id ? 'brand' : 'neutral'}
                  as="span"
                >
                  {option.bullet}
                </Text>
              </styled.Bullet>
            )}
          </styled.Tab>
        ))}
      </styled.Tabs>
      <Divider />
    </div>
  );
}

function getTitleColor(option: TOption, value?: number | string): Color {
  if (option.disabled) return 'neutral-weak';
  if (value === option.id) return 'brand';
  return 'neutral-strong';
}

export default Tabs;
